import getConfig from 'next/config'
import { IconProps } from '@chakra-ui/core'

interface RouteItem {
  name: string
  path: string
  icon: IconProps['name']
}

export interface Route {
  title: string
  routes: RouteItem[]
}

export const config = {
  ...getConfig(),
}

console.log('config', config)

// /**
//  * Replacement for Next.js publicRuntimeConfig (removed in Next.js 16)
//  * This provides the same API but uses environment variables directly
//  *
//  * Migration guide:
//  * - Replace: import getConfig from '@/utils/getPublicRuntimeConfig';
//  * - With: import getConfig from '@/utils/getPublicRuntimeConfig';
//  *
//  * Or use directly:
//  * - import { getPublicRuntimeConfig } from '@/utils/getPublicRuntimeConfig';
//  * - const publicRuntimeConfig = getPublicRuntimeConfig();
//  */

// export function getPublicRuntimeConfig() {
//   return {
//     backendRoot:
//       process.env.BACKEND_URL || process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:4000',
//     humpclubRoot:
//       process.env.HUMPCLUB_URL || process.env.NEXT_PUBLIC_HUMPCLUB_URL || 'http://localhost:4001',
//     PUBLIC_ENVS: Object.keys(process.env)
//       .filter(key => key.startsWith('NEXT_PUBLIC_'))
//       .reduce((acc, key) => ({ ...acc, [key]: process.env[key] }), {}),
//   }
// }

// /**
//  * For backward compatibility, export a default function that mimics getConfig()
//  * This allows existing code to work without immediate changes:
//  *
//  * import getConfig from '@/utils/getPublicRuntimeConfig';
//  * const { publicRuntimeConfig } = getConfig();
//  */
// export default function getConfig() {
//   // Client-side: window.runtimeConfig is already an object (injected by _document.tsx)
//   if (typeof window !== 'undefined' && (window as any).runtimeConfig) {
//     return {
//       publicRuntimeConfig: (window as any).runtimeConfig,
//     }
//   }
//   // Server-side: read from process.env at runtime
//   return {
//     publicRuntimeConfig: getPublicRuntimeConfig(),
//   }
// }
